import { LOOKER_HOSTS } from '../constants';

export enum EventType {
  PagePropertiesChanged = 'page:properties:changed',
  DashboardLoaded = 'dashboard:loaded',
  FrameLoad = 'frame:load',
}

export interface PagePropertiesChanged {
  type: EventType.PagePropertiesChanged;
  height: number;
}

export interface FrameLoad {
  type: EventType.FrameLoad;
}
export interface DashboardLoaded {
  type: EventType.DashboardLoaded;
}

export type LookerEvents = PagePropertiesChanged | FrameLoad | DashboardLoaded;

const handleLookerEvent = (
  event: MessageEvent<string>,
  setFrameHeight: (height: string) => void,
  setFrameDataLoaded: (loaded: boolean) => void,
  setIsError: (value: boolean) => void,
) => {
  const lookerEvent: LookerEvents = JSON.parse(event.data);

  switch (lookerEvent.type) {
    case EventType.PagePropertiesChanged:
      setFrameHeight(`${lookerEvent.height}px`);
      break;
    case EventType.DashboardLoaded:
      setFrameDataLoaded(true);
      break;
    // If the looker url is invalid, we get this message instead of the usual
    // two above. This is therefore being used to detect an error. There may
    // be a better way to do this.
    case EventType.FrameLoad:
      setIsError(true);
      break;
    default:
      break;
  }
};

export const createPostMessageEventHandler = (
  iframe: HTMLIFrameElement,
  setFrameHeight: (height: string) => void,
  setFrameDataLoaded: (loaded: boolean) => void,
  setIsError: (value: boolean) => void,
) => (event: MessageEvent<string>) => {
  if (event.source === iframe?.contentWindow) {
    if (LOOKER_HOSTS.includes(event.origin)) {
      handleLookerEvent(event, setFrameHeight, setFrameDataLoaded, setIsError);
    }
  }
};
